import React, { useRef, useState } from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import styles from "./styles.module.scss";
import MessageListComponent from "./MessageListComponent";

const MessageDialog = ({ rows, isLoading, setErrorResponse, prNo, msgLabelKey, errorKey, showClipboard }) => {
  const ref = useRef();

  return (
    <>
      <Dialog
        open={!!rows}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className={`${styles["select-concession-popup"]}`}>
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <div className="heading-4 color-dark">Messages</div>
            <div style={{ marginLeft: "auto" }}>
              <CrossIcon
                width={24}
                height={24}
                onClick={() => {
                  setErrorResponse(null);
                }}
              />
            </div>
          </div>

          <div>
            <MessageListComponent
              rows={rows}
              prNo={prNo}
              loading={isLoading}
              showClipboard={showClipboard}
              msgLabelKey={msgLabelKey}
              errorKey={errorKey}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default MessageDialog;
